const mutations = {
  SET_SHIPPING_SERVICES (state, payload) {
    state.shippingServices = payload
  },
  SET_STORE_SHIPPING_CONFIGS (state, payload) {
    state.storeShippingConfigs = payload
  },
  SET_AVAILABLE_SHIPPING_SERVICES (state, payload) {
    state.availableShippingServices = payload
  }
}

export default mutations
